// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2_U-M","buttons":"PendingPaymentAlert_buttons__2mqUo"};